<template>
    <el-dialog
        :visible.sync="couponVisible"
        :show-close="false"
        center
        width="914px"
        class="coupon_modal"
        :before-close="handleClose">
        <div class="coupon_modal_title">选择优惠券</div>
        <div>
            <div><el-radio v-model="radio"  label="-1"><span style="font-size:14px;color:#333;font-weight:500">不使用优惠券</span></el-radio></div>
            <div class="coupon_modal_box">
                <div v-for="item in couponList" :key="item.id">
                    <el-radio class="coupon_modal_radio" :value="item.id" v-model="radio" :label="item.id"><span></span></el-radio>
                    <div class="coupon_modal_box_items">
                        <div class="coupon_modal_box_item">
                            <div class="coupon_modal_box_item_left">
                                <img class="coupon_modal_box_item_left_img" src="../../../assets/coupon/coupon_type1.png" alt="">
                                <div class="coupon_modal_box_item_left_money">
                                    <span class="coupon_modal_box_item_left_money_unit">￥</span>
                                    <span class="coupon_modal_box_item_left_money_num">{{item.reduce}}</span>
                                </div>
                                <div class="coupon_modal_box_item_left_msg">
                                    满{{item.full}}元可用
                                </div>
                            </div>
                            <div class="coupon_modal_box_item_line"></div>
                            <div class="coupon_modal_box_item_right">
                                <p class="coupon_modal_box_item_right_title">{{item.card_name}}</p>
                                <p class="coupon_modal_box_item_right_time">使用时间：{{item.start_time}}-{{item.end_time}}</p>
                                <div class="coupon_modal_box_item_right_msg">
                                    <div>使用说明</div>
                                    <img @click="selectId = item.id" v-if="selectId != item.id" src="../../../assets/coupon/coupon_icon_down.png" alt="">
                                    <img @click="selectId = ''" v-if="selectId == item.id" src="../../../assets/coupon/coupon_icon_up.png" alt="">
                                </div>
                            </div>
                        </div>
                        <div class="coupon_modal_box_msg" v-if="selectId == item.id">
                            <p>1.{{item.instructions}}</p>
                            <p>2.满{{item.reduce}}元可用</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="coupon_modal_btn">
            <el-button type="primary" @click="selectCoupon">确认选择</el-button>
        </div>
    </el-dialog>
   
</template>

<script>
export default {
    props:["couponVisible",'couponCallback',"couponId"],
   data (){
       return {
           radio:'-1',
           couponList:[],
           loading:false,
           selectId:-1
           
       }
   },
   components: {
       
   },
   watch: {
       
   },
   computed: { 
       
   },
   methods: { 
       handleClose(){
           this.$emit('update:couponVisible',false);
       },
       selectCoupon(){
           let findIndex = _.findIndex(this.couponList , item => {
               return item.id == this.radio;
           });
           if(findIndex == -1){
               this.couponCallback({});
           }else{
               this.couponCallback(this.couponList[findIndex]);
           }
       },
       getCouponList(){
           this.loading = true;
           this.couponList = [];
           let params = {
               page_index:1,
               page_size:100,
               type:-1
           }
           this.$get('coupon',params)
                .then(data => {
                    this.loading = false;
                    this.couponList = data.data;
                } , error => {
                    this.loading = false;
                    this.$message.error(error);
                });
       },
   },
   created() {
       this.getCouponList();
       console.log(this.couponId);
       if(this.couponId){
           this.radio = this.couponId;
       }
   },
   mounted() {
       
   }
}
</script>

<style scoped lang='less'>
.coupon_modal{
    .coupon_modal_radio{
        position: relative;
        top:62px;
    }
    /deep/ .el-radio__label{
        // display: none;
    }
    /deep/ .el-radio{
        margin-right: 0;
    }
    &_content{
        display: flex;
        align-items: center;
        margin-top:20px;
        position: relative;
    }
    &_title{
        font-size: 20px;
        color:#333;
        font-weight: 500;
        height: 28px;
        line-height: 28px;
        text-align: center;
    }
    &_btn{
        text-align:center;
        margin-top:40px;
        /deep/ .el-button{
            height: 36px;
            padding: 10px 16px;
            margin-left: 5px;
            font-size: 16px;
            font-weight: 400;
        }
    }
    &_box{
        display: flex;
        flex-wrap:wrap;
        
        &_items{
            margin-left: 30px;
            margin-right:30px;
        }
        &_item{
            width:360px;
            height: 100px;
            background:url('../../../assets/coupon/coupon_bg1.png') no-repeat;
            background-size: 360px 100px;
            // margin-top:20px;
            display: flex;
            &_left{
                position: relative;
                width:96px;
                &_img{
                    position:absolute;
                    width:44px;
                    left:0;
                    top:0;
                }
                &_money{
                    text-align: center;
                    color:#fff;
                    margin-top:30px;
                    font-weight: 800;
                    display: flex;
                    justify-content:center;
                    align-items:flex-end;
                    &_unit{
                        font-size:12px;
                    }
                    &_num{
                        font-size:20px;
                        line-height: 20px;
                    }
                }
                &_msg{
                    color:#FDB5B3;
                    font-size: 14px;
                    font-weight: 400;
                    text-align: center;
                    margin-top:10px;
                }
            }
            &_line{
                width:1px;
                height:58px;
                border-left:1px dashed #FDB5B3;
                margin-top:21px;

            }
            &_right{
                width:254px;
                margin-left:10px;
                font-size: 14px;
                line-height: 14px;;
                &_title{
                    font-weight: 500;
                    color:#fff;
                    margin:14px 0 14px 0;
                }
                &_time{
                    color:#FDB5B3;
                    margin-bottom:14px;
                }
                &_msg{
                    color:#FDB5B3;
                    display: flex;
                    justify-content:space-between;
                    align-items:center;
                    img{
                        width:10px;
                        height: 10px;
                        margin-right:37px;
                        cursor: pointer;
                    }
                }
            }
            
        }
        &_msg{
            width:360px;
            padding:16px 20px 10px 10px;

            background:#F7F9FC;
            
            p{
                height: 25px;
                color:#A6AEC1;
                line-height: 25px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/order/components/coupon.vue